import authService from '@/modules/Auth/auth-services'
import { User } from '@/modules/Auth/classes/User'
import { ClinicAndFlags } from '@/modules/Auth/auth-types'
import * as braze from '@braze/web-sdk'

export const startBrazeSdk = async (user: User): Promise<void> => {
  const userClinic: ClinicAndFlags = await authService.getClinic(user.token)
  const patientId = user.patientId
  const allowBraze = userClinic?.flags?.PermiteEnvioBraze
  const allowPush = userClinic?.flags?.PermitePush
  if (!braze || !patientId || !allowBraze) return
  let sdkKey = process.env.VITE_APP_BRAZE_SDK_KEY_CONEXA
  let sdkEndpoint = process.env.VITE_APP_BRAZE_SDK_ENDPOINT_CONEXA
  let sdkWebSitePushId = 'web.br.com.conexasaude'
  const enableLogging = `${process.env.VITE_APP_ENV_NAME}` !== 'PROD'
  if (userClinic?.flags?.IsDocpass) {
    sdkKey = process.env.VITE_APP_BRAZE_SDK_KEY_DOCPASS
    sdkEndpoint = process.env.VITE_APP_BRAZE_SDK_ENDPOINT_DOCPASS
    sdkWebSitePushId = 'web.br.com.docpass'
  }
  braze.initialize(sdkKey, {
    baseUrl: sdkEndpoint,
    allowUserSuppliedJavascript: true,
    manageServiceWorkerExternally: false,
    safariWebsitePushId: sdkWebSitePushId,
    enableLogging: enableLogging,
  })
  const idPatient = String(patientId)
  braze.changeUser(idPatient)
  braze.openSession()
  if (allowPush && braze.isPushSupported() && !braze.isPushBlocked()) {
    braze.requestPushPermission()
  }
  navigator.geolocation.getCurrentPosition(position => {
    const coords = position.coords
    braze
      .getUser()
      .setLastKnownLocation(
        coords.latitude,
        coords.longitude,
        coords.accuracy,
        coords.altitude,
        coords.altitudeAccuracy,
      )
  })
  braze.automaticallyShowInAppMessages()
  braze.subscribeToInAppMessage(function (inAppMessage) {
    braze.showInAppMessage(inAppMessage)
  })
}
